module.exports = __webpack_public_path__ + "media/images/iconSocialMail__errorRed-0f3c23c0fffcf749c4ae8dc2eed62f68.png";